import { render, staticRenderFns } from "./dinogems.vue?vue&type=template&id=721435dc&scoped=true"
import script from "./dinogems.vue?vue&type=script&lang=js"
export * from "./dinogems.vue?vue&type=script&lang=js"
import style0 from "./dinogems.vue?vue&type=style&index=0&id=721435dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721435dc",
  null
  
)

export default component.exports